import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
    path: '/profitCenter',
    component: () =>
        import ('@/layout/index'),
    redirect: 'profitCenter/commission',
    meta: {
        title: i18n.t('fen-run-zhong-xin'),
        icon: 'icon-yingxiao1',
        perms: ['bee:profitCenter']
    },
    // hidden: true,
    children: [{
        path: 'profit',
        component: () =>
            import ('@/module/profitCenter/page/profit/manage.vue'),
        meta: {
            title: i18n.t('fen-run-guan-li'),
            icon: 'icon-guanggao',
            perms: ['bee:profit:administration']
        }
    }, {
        path: 'investment',
        component: () =>
            import ('@/module/profitCenter/page/investment/manage.vue'),
        meta: {
            title: i18n.t('wo-de-tou-zi'),
            icon: 'icon-guanggao',
            perms: ['bee:profit:investment']
        }
    }, {
      path: 'dataManager',
      component: () =>
        import ('@/module/profitCenter/page/dataManager/manage.vue'),
      meta: {
        title: i18n.t('fen-run-shu-ju-guan-li'),
        icon: 'icon-guanggao',
        perms: ['bee:profit:datamanager']
      }
    }, {
        path: 'paymentAudit',
        component: () =>
            import ('@/module/profitCenter/page/paymentAudit/manage.vue'),
        meta: {
            title: i18n.t('zhuan-zhang-hui-kuan'),
            icon: 'icon-guanggao',
            perms: ['bee:profit:remittance']
        }
    }]
}]


// WEBPACK FOOTER //
// ./src/module/profitCenter/router/index.js